
import { useState, useEffect, useCallback } from "react";
import { useSession } from "@/hooks/useSession";
import { useFetchResourceProgress } from "./hooks/useFetchResourceProgress";

export function useResourceCardStatus(id: string, isTrainee: boolean) {
  const { session } = useSession();
  const {
    progress,
    isCompleted,
    completedAt,
    isCalculatingProgress,
    fetchProgress
  } = useFetchResourceProgress(id, isTrainee);

  useEffect(() => {
    if (isTrainee && session?.user?.id) {
      fetchProgress();
    }
  }, [isTrainee, session?.user?.id, id, fetchProgress]);

  return {
    progress,
    isCompleted,
    completedAt,
    isCalculatingProgress,
    fetchProgress
  };
}
